import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PriorityFeedCapabilityConfiguration } from '../../configuration';
import { STCConfigsModel } from '../../models/stcconfigs_model';
import { SelfAlertDialogQuery } from '../../queries/self_alert_dialog_query';
import { OpenableElementsQuery } from '../../queries/openable_elements_query';
import { SelfAlertIconDetailsQuery } from '../../queries/self_alert_icon_details_query';

interface ISelfAlertSubmitData {
  alert_reason_ids: number[];
  enrollment_ids?: number[];
  comments?: string;
}

interface ISelfAlertFormSubmitOutput {
  detail: {
    value: ISelfAlertSubmitData;
  };
}

export class SelfAlertDialogController {
  private isSelfAlertEnabled: boolean;
  private showSelfAlert: boolean = false;
  private selfAlert: any;
  constructor(
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration,
    private ngOpenableElementsQuery: OpenableElementsQuery,
    private ngSTCConfigsModel: STCConfigsModel,
    private getSelfAlertDataCommand: ICommand,
    private ngSelfAlertDialogQuery: SelfAlertDialogQuery,
    private closeOpenableElementCommand: ICommand,
    private submitSelfAlertCommand: ICommand,
    private $element: ng.IAugmentedJQuery,
    private $state: ng.ui.IStateService,
    private loadSelfAlertIconDetailsCommand: ICommand,
    private ngSelfAlertIconDetailsQuery: SelfAlertIconDetailsQuery,
    private appConfigModel: any
  ) {}

  closeSelfAlert() {
    const dialog = this.$element[0].querySelector('#self-alert-dialog');
    if (dialog) {
      dialog.removeAttribute('opened');
    }
    return this.closeOpenableElementCommand('selfAlertDialog');
  }

  getSelfAlertLabel() {
    return this.ngSTCConfigsModel.read().self_alert_label;
  }

  $onInit(): void {
    this.selfAlert = this.appConfigModel.model.SELF_ALERT_HELP;
    if (this.appConfigModel.isFeatureEnabled('ssccampus-self_alert_create')) {
      this.getSelfAlertDataCommand();
      this.loadSelfAlertIconDetailsCommand();
    }
  }

  clearAndCloseDialog() {
    (this.$element[0].querySelector<HTMLFormElement>('#self-alert-form') as unknown as HTMLFormElement)['reset']();
    this.closeSelfAlert();
  }

  onSelfAlertFormSubmitted($event: ISelfAlertFormSubmitOutput) {
    const submitButton = this.$element[0].querySelector('#self-alert-dialog-save');
    if (submitButton) {
      submitButton.setAttribute('locked', '');
    }
    const selfAlertFormData: any = _4.get($event, 'detail.value', {});

    this.submitSelfAlertCommand(selfAlertFormData)
      .then(() => {
        this.clearAndCloseDialog();
      })
      .finally(() => {
        if (submitButton) {
          submitButton.removeAttribute('locked');
        }
      });
  }
}
export class SelfAlertDialogComponent implements ng.IComponentOptions {
  public controller: object = SelfAlertDialogController;
  public templateUrl: string = 'capability-ng-priority-feed/src/components/self_alert_dialog/self_alert_dialog.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/self_alert_dialog/self_alert_dialog.ts